import List from "@mui/material/List";
import useSidebar from "components/Sidebar/SidebarProvider/useSidebar";

interface ListRouteItemProps {
  children?: React.ReactNode;
}

function ListRouteItem(props: ListRouteItemProps) {
  const { children } = props;
  const { open } = useSidebar();

  return (
    <List
      data-open={open}
      sx={{
        display: "flex",
        flexDirection: "column",
        p: "4px 0",
        gap: "4px",

        "&[data-open='false']": {
          gap: "6px",
          padding: "12px 0",
        },
      }}
    >
      {children}
    </List>
  );
}

export default ListRouteItem;
